import { render, staticRenderFns } from "./FormResponsible.vue?vue&type=template&id=554ff445"
import script from "./FormResponsible.vue?vue&type=script&lang=js"
export * from "./FormResponsible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports